import {WlFavorite} from "./favorite.component";

export * from './favorite.component';
export default WlFavorite;

customElements.define('wl-favorite', WlFavorite);
